module.exports = __webpack_public_path__ + "img/img-10.cede8f0e.webp";